import type IRawPageSourceFetchResult from '@/interfaces/IRawPageSourceFetchResult';

/**
 * Produce a plain (non-reactive) placeholder result for a skipped fetch.
 */
export const createAbortFetchResult =
    (): IRawPageSourceFetchResult => ({ data: null, statusCode: null });  // use null to mean “aborted”
